import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Moment from 'moment';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import TooltipButton from './TooltipButton';
import TooltipLink from './TooltipLink';

Moment.locale('en');

class OrganisationPlayersTable extends Component {
    copyEmailToClipboard = (email) => {
        navigator.clipboard.writeText(email).catch(err => {
            console.error('Failed to copy email:', err);
        });
    };

    didConfirmDelete(player) {
        this.props.onDelete(player);
    }

    handleDeleteClicked(player) {
        const { t } = this.props;

        this.dialog.show({
            title: t('Dialog.warning'),
            body: t('Dialog.sure_deletion'),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.didConfirmDelete(player),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    showNotesModal = (notes) => {
        const { t } = this.props;
        this.dialog.show({
            title: t('OrganisationPlayersTable.notes'),
            body: (
                <div style={{ whiteSpace: 'pre-wrap', maxHeight: '400px', overflowY: 'auto' }}>
                    {notes}
                </div>
            ),
            actions: [
                Dialog.Action(
                    t('Dialog.close'),
                    () => this.dialog.hide(),
                    'btn-default'
                )
            ],
            bsSize: 'large'
        });
    };

    handleCheckboxChange = (playerUuid) => {
        const { selectedPlayers, excludedPlayers, selectAllMode } = this.props;

        let isCurrentlySelected;
        if (selectAllMode) {
            isCurrentlySelected = !excludedPlayers.has(playerUuid);
        } else {
            isCurrentlySelected = selectedPlayers.has(playerUuid);
        }

        this.props.onSelectPlayer(playerUuid, !isCurrentlySelected);
    };

    handleSelectAllChange = () => {
        // Check if all current page items are selected
        const { selectedPlayers, excludedPlayers, selectAllMode } = this.props;
        const allCurrentPageSelected = this.props.players.every(player => {
            return selectAllMode
                ? !excludedPlayers.has(player.uuid)
                : selectedPlayers.has(player.uuid);
        });

        // Toggle: if all are selected, deselect all; otherwise select all
        this.props.onSelectAll(!allCurrentPageSelected);
    };

    render() {
        const { t, uuid, selectedPlayers, excludedPlayers, selectAllMode, userIsAuthorized, user } = this.props;

        const isSuperAdmin = userIsAuthorized(user, ['staff_super_admin']);

        // Determine if all current page items are selected
        const allCurrentPageSelected = this.props.players.every(player => {
            return selectAllMode
                ? !excludedPlayers.has(player.uuid)
                : selectedPlayers.has(player.uuid);
        });

        // Determine if some (but not all) items are selected
        const someSelected = this.props.players.some(player => {
            return selectAllMode
                ? !excludedPlayers.has(player.uuid)
                : selectedPlayers.has(player.uuid);
        });

        let playerRows = this.props.players.map((player, index) => {
            const isSelected = selectAllMode
                ? !excludedPlayers.has(player.uuid)
                : selectedPlayers.has(player.uuid);

            return (
                <tr key={index}>
                    {isSuperAdmin && (
                        <td align="center" width={40}>
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => this.handleCheckboxChange(player.uuid)}
                            />
                        </td>
                    )}
                    <td align="center" width={80}>
                        <OverlayTrigger
                            placement="top"
                            delayShow="300"
                            delayHide="150"
                            overlay={
                                <Tooltip id="tooltip">
                                    <strong>
                                        {t(
                                            'OrganisationPlayersTable.previewplayer'
                                        )}
                                    </strong>
                                </Tooltip>
                            }
                        >
                            <a
                                id="previewButton"
                                className="btn btn-primary"
                                target="_blank"
                                href={`${
                                    config.playersBaseURL
                                }/mediaserver/unit.php?playerUUID=${
                                    player.uuid
                                }&preview=1`}
                            >
                                <em className="fa fa-eye" />
                            </a>
                        </OverlayTrigger>
                    </td>
                    <td className="hidden-xs hidden-sm">
                        {player.online ? (
                            <span className="label label-success">
                                {t('OrganisationPlayersTable.online')}
                            </span>
                        ) : (
                            <span className="label label-danger">
                                {t('OrganisationPlayersTable.offline')}
                            </span>
                        )}
                    </td>

                    <td>
                        <Link
                         id="playerButton"
                         style={{
                            alignItems: "center",
                            textAlign: "left"
                          }}
                         className="label label-primary"
                         to={`/organisations/${uuid}/players/${player.uuid}`}
                        >
                            {player.name}
                        </Link>

                    
                    </td>
                    <td className="hidden-xs hidden-sm">{player.location}</td>
                    <td className="hidden-xs hidden-sm">{player.macAddress}</td>
                    <td className="hidden-xs hidden-sm">
                        {player.serialNumber}
                    </td>
                    <td className="hidden-xs hidden-sm">
                        {player.notes ? (
                            player.notes.length > 100 ? (
                                <span
                                    className="label label-info"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.showNotesModal(player.notes)}
                                >
                                    <em className="fa fa-sticky-note" /> Notes
                                </span>
                            ) : (
                                <OverlayTrigger
                                    placement="top"
                                    delayShow="300"
                                    delayHide="150"
                                    overlay={
                                        <Tooltip id={`notes-tooltip-${index}`}>
                                            {player.notes}
                                        </Tooltip>
                                    }
                                >
                                    <span className="label label-info" style={{ cursor: 'pointer' }}>
                                        <em className="fa fa-sticky-note" /> Notes
                                    </span>
                                </OverlayTrigger>
                            )
                        ) : (
                            <span className="text-muted">—</span>
                        )}
                    </td>
                    <td className="hidden-xs hidden-sm">
                        {player.email ? (
                            <OverlayTrigger
                                placement="top"
                                delayShow="300"
                                delayHide="150"
                                overlay={
                                    <Tooltip id={`email-tooltip-${index}`}>
                                        {player.email} (click to copy)
                                    </Tooltip>
                                }
                            >
                                <span
                                    className="label label-success"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.copyEmailToClipboard(player.email)}
                                >
                                    <em className="fa fa-envelope" />
                                </span>
                            </OverlayTrigger>
                        ) : (
                            <span className="text-muted">—</span>
                        )}
                    </td>
                    <td className="hidden-xs hidden-sm hidden-md">
                        {Moment(player.installDate).format('YYYY-MM-DD HH:mm')}
                    </td>
                    <td className="hidden-xs">
                        {player.lastSeen
                            ? Moment(player.lastSeen).fromNow()
                            : t('OrganisationPlayersTable.never')}
                    </td>
                    <td align="center" width={160}>
                        {this.props.userIsAuthorized(this.props.user, [
                            'staff_super_admin',
                            'staff_admin',
                            'organisation_admin',
                            'organisation_publisher'
                        ]) ? (
                            <TooltipLink
                                id="editButton"
                                className="btn btn-default"
                                tooltip={t(
                                    'OrganisationPlayersTable.attributes'
                                )}
                                to={`/organisations/${uuid}/players/${
                                    player.uuid
                                }/attributes?rel=org`}
                            >
                                <em className="fa fa-tags" />
                            </TooltipLink>
                        ) : null}

                        {this.props.userIsAuthorized(this.props.user, [
                            'staff_super_admin',
                            'staff_admin',
                            'organisation_admin'
                        ]) ? (
                            <TooltipLink
                                id="editButton"
                                className="btn btn-default"
                                tooltip={t(
                                    'OrganisationPlayersTable.editplayer'
                                )}
                                to={`/organisations/${uuid}/players/${
                                    player.uuid
                                }/edit?rel=org`}
                            >
                                <em className="fas fa-pencil-alt" />
                            </TooltipLink>
                        ) : null}

                        {this.props.userIsAuthorized(this.props.user, [
                            'staff_super_admin'
                        ]) ? (
                            <TooltipButton
                                id="deleteButton"
                                className="btn-danger pull-right"
                                tooltip={t(
                                    'OrganisationPlayersTable.deleteplayer'
                                )}
                                onClick={() => this.handleDeleteClicked(player)}
                            >
                                <em className="fa fa-trash" />
                            </TooltipButton>
                        ) : null}
                    </td>
                </tr>
            );
        });

        return (
            <div id="players" className="playerTable">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            {isSuperAdmin && (
                                <th width="40">
                                    <input
                                        type="checkbox"
                                        checked={allCurrentPageSelected && this.props.players.length > 0}
                                        ref={(input) => {
                                            if (input) {
                                                input.indeterminate = someSelected && !allCurrentPageSelected;
                                            }
                                        }}
                                        onChange={this.handleSelectAllChange}
                                        title="Select all players on this page"
                                    />
                                </th>
                            )}
                            <th>{t('OrganisationPlayersTable.preview')}</th>
                            <th width="80" className="hidden-xs hidden-sm">
                                {t('OrganisationPlayersTable.status')}
                            </th>
                            <th>{t('OrganisationPlayersTable.name')}</th>
                            <th className="hidden-xs hidden-sm">
                                {t('OrganisationPlayersTable.location')}
                            </th>
                            <th className="hidden-xs hidden-sm">
                                {t('OrganisationPlayersTable.mac_address')}
                            </th>
                            <th className="hidden-xs hidden-sm">
                                {t('OrganisationPlayersTable.serial_number')}
                            </th>
                            <th className="hidden-xs hidden-sm">
                                {t('OrganisationPlayersTable.notes')}
                            </th>
                            <th className="hidden-xs hidden-sm" width="60">
                                <img src={require('../email.png')} alt="Email" style={{ width: '24px', height: '24px' }} />
                            </th>
                            <th className="hidden-xs hidden-sm hidden-md">
                                {t('OrganisationPlayersTable.install_date')}
                            </th>
                            <th className="hidden-xs">
                                {t('OrganisationPlayersTable.last_seen')}
                            </th>
                            <th>
                                <em className="fa fa-cog" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{playerRows}</tbody>
                </Table>
            </div>
        );
    }
}

export default translate('translations')(OrganisationPlayersTable);
